import type { FC } from 'react'

import AirlineStopsIcon from '@mui/icons-material/AirlineStops'
import CloseIcon from '@mui/icons-material/Close'
import DoneIcon from '@mui/icons-material/Done'
import Avatar from '@mui/material/Avatar'
import Chip from '@mui/material/Chip'
import Tooltip from '@mui/material/Tooltip'

import type { AssignedBijlage } from '../types/AssignedBijlage'
import type { AssignedBijlageLog } from '../types/AssignedBijlageLog'

const statusLabelDict = {
  assigned: 'Toegewezen',
  uploaded: 'Bijlagen toegevoegd',
  review: 'Ter beoordeling aangeboden',
  done: 'Afgerond',
  cancelled: 'Geannuleerd',
}

const logStatusLabel = (
  logEntry: AssignedBijlageLog,
  assignedBijlage: AssignedBijlage,
) => {
  const { status } = logEntry

  if (status === 'waiting') {
    return `Wacht op ${assignedBijlage.waitFor}`
  }

  return statusLabelDict[status]
}

interface Props {
  logEntry: AssignedBijlageLog
  assignedBijlage: AssignedBijlage
}

export const AssignedBijlageLogStatus: FC<Props> = ({
  logEntry,
  assignedBijlage,
}) => {
  const { requiresReview } = assignedBijlage
  const { status, reden, continued } = logEntry
  const statusText = logStatusLabel(logEntry, assignedBijlage)
  const isAfgekeurd = requiresReview && status === 'uploaded' && reden
  const isGoedgekeurd = requiresReview && status === 'done'
  const isContinued = requiresReview && status === 'assigned' && continued

  return (
    <>
      {!isAfgekeurd && !isGoedgekeurd && !isContinued && statusText}
      {isAfgekeurd && (
        <Tooltip title={`Reden afkeur: ${reden}`}>
          <Chip
            label="Afgekeurd"
            variant="outlined"
            color="error"
            sx={{
              backgroundColor: 'white',
              borderColor: 'red',
            }}
            avatar={
              <Avatar>
                <CloseIcon
                  color="error"
                  sx={{
                    cursor: 'default',
                    backgroundColor: 'white',
                  }}
                />
              </Avatar>
            }
          />
        </Tooltip>
      )}

      {isGoedgekeurd && (
        <Chip
          label="Afgerond"
          variant="outlined"
          color="success"
          sx={{
            backgroundColor: 'white',
          }}
          avatar={
            <Avatar>
              <DoneIcon
                color="success"
                sx={{
                  cursor: 'default',
                  backgroundColor: 'white',
                }}
              />
            </Avatar>
          }
        />
      )}

      {isContinued && (
        <Chip
          label="Wordt vervolgd"
          variant="outlined"
          color="info"
          sx={{
            backgroundColor: 'white',
          }}
          avatar={
            <Avatar>
              <AirlineStopsIcon
                color="info"
                sx={{
                  cursor: 'default',
                  backgroundColor: 'white',
                }}
              />
            </Avatar>
          }
        />
      )}
    </>
  )
}
